import { Modal } from '@mui/material';
import { appDelay, DillTransaction } from '@dill/dill-shared';
import { useAppDispatch, useAppSelector } from '../../../../redux/store';
import { openMessageModal } from '../../../../redux/globalSlices/genericSlice';
import { refundFiservTransaction } from '../../../../redux/services/paymentsService';
import { AppInputField } from '../../../general/AppInputField/AppInputField';
import { AppButton } from '../../../general/AppButton/AppButton';
import { useEffect, useState } from 'react';

function FiservRefundModal({
  open,
  selectedTransaction,
  handleClose = () => {},
}: {
  open: boolean;
  selectedTransaction: DillTransaction | undefined | null;
  handleClose: (isRefunded?: boolean) => void;
}) {
  const { user } = useAppSelector((state) => state.auth);
  const currentSupplier = useAppSelector((state) => state.auth.currentSupplier);
  const dispatch = useAppDispatch();
  const [amountToRefund, setAmountToRefund] = useState(0);
  const [isShowErrors, setIsShowErrors] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (selectedTransaction && open) {
      setAmountToRefund(selectedTransaction.totalAmountPaid);
    }
  }, [selectedTransaction, open]);

  useEffect(() => {
    if (!open) {
      setAmountToRefund(0);
      setIsShowErrors(false);
      setErrorMessage('');
    }
  }, [open]);

  const checkErrors = () => {
    let isError = false;
    if (Number(amountToRefund) === 0) {
      isError = true;
    }
    if (selectedTransaction && amountToRefund > selectedTransaction?.totalAmountPaid) {
      isError = true;
    }
    return isError;
  };

  const handleRefundFiservTransaction = async () => {
    try {
      if (!selectedTransaction) {
        return;
      }
      setIsShowErrors(true);
      console.log(amountToRefund);
      if (amountToRefund === 0) {
        return;
      }

      dispatch(
        openMessageModal({
          buttonText: 'Close',
          modalType: 'WARN',
          title: `Are you sure you would like to refund this transaction?`,
          subTitle: 'This transaction will be refunded.',
          secondButtonText: 'Proceed',
          isSecondButton: true,
          onSecondButtonClick: async () => {
            await appDelay(10);
            dispatch(
              openMessageModal({
                buttonText: '',
                modalType: 'LOADING',
                title: 'Refunding',
                subTitle: 'Refunding transaction',
              })
            );
            const res = await dispatch(
              refundFiservTransaction({
                supplierId: currentSupplier?.id || '',
                transactionId: selectedTransaction?.id || '',
                amountToRefund: amountToRefund,
              })
            );
            if (res && res.type === 'payments/refundFiservTransaction/fulfilled') {
              dispatch(
                openMessageModal({
                  buttonText: 'Close',
                  modalType: 'SUCCESS',
                  title: 'Refund successful.',
                  subTitle:
                    'Please handle the reconciliation of this in your accounting system accordingly.',
                  onClose: () => {
                    handleClose(true);
                  },
                })
              );
            } else {
              const payload: any = res.payload;
              let payloadErrorMessage = 'Error while refunding transaction';
              if (payload) {
                payloadErrorMessage = payload;
              }
              dispatch(
                openMessageModal({
                  buttonText: 'Close',
                  modalType: 'ERROR',
                  title: 'Error refunding transaction',
                  subTitle: `${payloadErrorMessage} Contact (628) 304-0931 for customer support`,
                })
              );
            }
          },
        })
      );
    } catch (err) {
      dispatch(
        openMessageModal({
          buttonText: 'Close',
          modalType: 'ERROR',
          title: 'Error refunding transaction',
          subTitle: 'Failed to refund transaction} Contact (628) 304-0931 for customer support',
        })
      );
      console.log(err);
    }
  };
  return (
    <Modal
      open={open}
      onClose={() => {
        handleClose();
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <div className="flex min-h-30  w-[90vw] md:w-[40vw] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg  flex-col px-2 py-2">
        <div className="flex items-center mt-2">
          <h3 className="font-bold text-xl">Refund Transaction</h3>
        </div>

        <div className="flex flex-col mt-5">
          <AppInputField
            label="Amount to refund"
            inputType="number"
            errorText={isShowErrors && amountToRefund === 0 ? 'Required' : ''}
            maxValue={selectedTransaction?.totalAmountPaid}
            value={amountToRefund}
            onBlur={() => {
              if (
                selectedTransaction &&
                Number(amountToRefund) > selectedTransaction?.totalAmountPaid
              ) {
                setErrorMessage('You can’t refund an amount greater than what was paid.');
              } else {
                if (Number(amountToRefund) === 0) {
                  setErrorMessage('You need to set amount to refund.');
                } else {
                  setErrorMessage('');
                }

                setAmountToRefund(Number(amountToRefund));
              }
            }}
            onTextChange={(val) => {
              setAmountToRefund(val);
              if (selectedTransaction && Number(val) > selectedTransaction?.totalAmountPaid) {
                setErrorMessage('You can’t refund an amount greater than what was paid.');
              } else {
                if (Number(val) === 0) {
                  setErrorMessage('You need to set amount to refund.');
                } else {
                  setErrorMessage('');
                }
              }
            }}
          />
          <p className="text-xs text-red-500">{errorMessage}</p>
          <div className="mt-2 flex justify-end">
            <div className="flex">
              <div className=" mr-1">
                <AppButton text="Close" type="SECONDARY" onClick={handleClose} />
              </div>

              <AppButton
                text="Refund"
                isDisabled={checkErrors()}
                onClick={handleRefundFiservTransaction}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default FiservRefundModal;
